import React, { useState } from 'react'
import { Lazyload, Button, Link } from '~/components'
import { scroller } from 'react-scroll'
import { Image as Item } from '~/components/Lightbox'
import cn from 'classnames'
import * as st from '~/assets/styl/ResalesList.module.styl'
import * as st1 from '~/assets/styl/EnterpriseSlider.module.styl'
import * as st2 from '~/assets/styl/Gallery.module.styl'

interface ResaleItem {
  id: string
  images: { url: string }[]
  location: string
  name: string
  features: string[]
  url: string
  whatsapp: string
  description: string
}

interface ResaleGroup {
  title: string
  items: ResaleItem[]
}

interface ResalesListProps {
  resalesGrouped: ResaleGroup[]
}

export default function ResalesList({ resalesGrouped }: ResalesListProps) {
  const [images, setImages] = useState<Array<Item>>()
  const [index, setIndex] = useState<number>(0)

  const onClick = (imgIndex: number, imgs: Array<Item>) => {
    setIndex(imgIndex)
    setImages(imgs)
  }

  return (
    <>
      {resalesGrouped.map((group, groupIndex) => (
        <section key={groupIndex} className={cn(st1.core, st.core)}>
          <div className={st1.container}>
            <h2>{group.title}</h2>

            {group.items.map((resale) => (
              <div key={resale.id} className={st.container}>
                {resale.images.map(({ url }, imgIndex) => (
                  <Lazyload
                    src={url}
                    key={imgIndex}
                    className={cn(st2.slide, st.slide)}
                    onClick={() => onClick(imgIndex, resale.images)}
                  />
                ))}

                <div className={st.text}>
                  <p className={st.location}>{resale.location}</p>
                  <h3>{resale.name}</h3>
                  <ul>
                    {resale.features.map((feature, i) =>
                      feature ? (
                        <li key={i}>
                          <span
                            className={`icon-${
                              i === 0 ? 'subtract' : 'currency'
                            }`}
                          ></span>
                          {feature}
                        </li>
                      ) : null
                    )}
                  </ul>
                  <p className={st.description}>
                    {resale.description.length > 220
                      ? resale.description.slice(0, 220) + '...'
                      : resale.description}
                  </p>
                  {resale.whatsapp && (
                    <Link
                      href={`https://wa.me/${resale.whatsapp.replace(
                        /[^0-9]/g,
                        ''
                      )}?text=${encodeURIComponent(
                        `Olá, fiquei interessado em receber mais informações sobre o imóvel ${resale.name} disponível no site da Votis.`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    ></Link>
                  )}
                  {resale.whatsapp && (
                    <div className={st.ctaWpp}>
                      <Link
                        href={`https://wa.me/${resale.whatsapp.replace(
                          /[^0-9]/g,
                          ''
                        )}?text=${encodeURIComponent(
                          `Olá, fiquei interessado em receber mais informações sobre o imóvel ${resale.name} disponível no site da Votis.`
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="icon-whatsapp"></span>Chamar no
                        whatsapp
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </>
  )
}
